














import {Component, Mixins, Prop, Vue} from 'vue-property-decorator';
import UserRoleMixin from "@/mixins/UserRoleMixin.vue";
@Component({
    components: {},
})
export default class CardholderInfoBadge extends Mixins(UserRoleMixin) {
    @Prop({default: ''})
    public name!: string;
    @Prop({default: ''})
    public email!: string;
    @Prop({default: ''})
    public phone!: number;
    @Prop({default: ()=>undefined})
    public color!: string;
    @Prop({default: false})
    public dark!: boolean;
    @Prop({default: false})
    public sideMargin!: boolean;

    public get formattedPhone(){
        const f = this.formatPhoneNumber(this.phone);
        return f ? f : this.phone.toString();
    }

    private formatPhoneNumber(phoneNumberString) {
        const cleaned = ('' + phoneNumberString).replace(/\D/g, '');
        const match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
        if (match) {
            var intlCode = (match[1] ? '+1 ' : '');
            return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('')
        }
        return null
    }
}
